export default (orderId, adjustment) =>
  localStorage.setItem(
    `orderAdjustment_${orderId}`,
    JSON.stringify(adjustment)
  );
